import { LoadInvitationStep } from "../components/steps/LoadInvitationStep";
import { IAdminInvitationFlowValues } from "../_interfaces/IAdminInvitationFlowValues";
import { FlowDefinition } from "../../interfaces/FlowInterfaces";
import { RequestNewInvitationStep } from "../components/steps/RequestNewInvitationStep";
import { LoginStep } from "../components/steps/LoginStep";
import { InvitationAcceptedStep } from "../components/steps/InvitationAcceptedStep";
import { TermsOfServiceStep } from "../components/steps/TermsOfServiceStep";
import { OrganizationProfileLimitStep } from "../components/steps/OrganizationProfileLimitStep";

export type StepIds =
  | "loadInvitation"
  | "requestNewInvitation"
  | "login"
  | "invitationAccepted"
  | "termsOfService"
  | "organizationProfileLimit";

export const adminInvitationFlow: FlowDefinition<
  StepIds,
  IAdminInvitationFlowValues
> = {
  initialStep: "loadInvitation",
  steps: {
    loadInvitation: {
      id: "loadInvitation",
      render: LoadInvitationStep,
      // TODO: Update
      // isComplete: (v) => ({
      //   valid: !!v.username,
      //   reason: "Please enter a username",
      // }),
      onSubmit: (v) =>
        v.requestNewLink
          ? { type: "goto", stepId: "requestNewInvitation" }
          : v.hasAccount
            ? { type: "goto", stepId: "login" }
            : v.inviteForCurrentUser
              ? v.hasExistingOrganizationProfile // TODO: Eventually remove this restriction
                ? { type: "goto", stepId: "organizationProfileLimit" }
                : { type: "goto", stepId: "termsOfService" }
              : v.invitationAccepted
                ? { type: "goto", stepId: "invitationAccepted" }
                : { type: "end" },
    },

    login: {
      id: "login",
      render: LoginStep,
      onSubmit: (v) =>
        !v.hasAccount
          ? { type: "goto", stepId: "loadInvitation" }
          : v.hasExistingOrganizationProfile
            ? { type: "goto", stepId: "organizationProfileLimit" }
            : v.userId > 0
              ? { type: "goto", stepId: "termsOfService" }
              : { type: "end" },
    },

    requestNewInvitation: {
      id: "requestNewInvitation",
      render: RequestNewInvitationStep,
      onSubmit: (v) =>
        v.requestNewLink
          ? { type: "goto", stepId: "loadInvitation" }
          : { type: "next" },
    },

    termsOfService: {
      id: 'termsOfService',
      render: TermsOfServiceStep,
      onSubmit: (v) =>
        v.termsOfServiceAccepted && v.userId > 0
          ? { type: "goto", stepId: "invitationAccepted" }
          : { type: "end" }
    },

    invitationAccepted: {
      id: 'invitationAccepted',
      render: InvitationAcceptedStep,
      onSubmit: (v) => { return { type: "end" } }
    },

    organizationProfileLimit: {
      id: 'organizationProfileLimit',
      render: OrganizationProfileLimitStep,
      onSubmit: (v) =>
        !v.hasExistingOrganizationProfile
          ? { type: "goto", stepId: "loadInvitation" }
          : { type: "end" }
    },
  },
};
